<template>
  <div
    v-editable="blok"
    class="EmployeeCardGroup"
    :class="[desktopWidth('full'), {
      'desk:text-center': blok.cards.length < 4 && blok.cards.length > 0
    }]"
  >
    <div class="empty:hidden type-headline-lg desk:type-headline-xl mobOnly:px-12 py-8 mb-12 leading-single">
      {{ blok.headline }}
    </div>

    <div
      :class="[
        'grid gap-4 desk:gap-12',
        'mobOnly:grid-cols-2',
        'grid-cols-[repeat(auto-fit,_minmax(280px,_1fr))]'
      ]"
    >
      <EmployeeCard
        v-for="card in blok.cards"
        :key="card._uid"
        :blok="card"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmployeeCardGroupProps } from '~/constants/types/storyblok';
import useDesktopWidth from '~/composeables/useDesktopWidth';

const props = defineProps<{
  blok: EmployeeCardGroupProps,
}>();

const { desktopWidth } = useDesktopWidth(props);
</script>

<style scoped lang="postcss">
</style>
